import axios from "axios";

const state = {
  locationEnabled: false,
  venues: [],
  loading: false
};

const getters = {};

const actions = {
  getVenues({ commit }, { latitude, longitude, radius }) {
    commit("SET_LOADING", true);
    commit("SET_VENUES", []);
    axios
      .get("venues/search", {
        baseURL: "https://api.foursquare.com/v2/",
        params: {
          client_id: process.env.VUE_APP_FOURSQUARE_CLIENT_ID,
          client_secret: process.env.VUE_APP_FOURSQUARE_CLIENT_SECRET,
          ll: `${latitude},${longitude}`,
          intent: "browse",
          radius: radius,
          v: 20190801
        }
      })
      .then(res => {
        const venueList = res.data.response.venues.sort((a, b) =>
          a.distance > b.distance ? 1 : -1
        );
        commit("SET_VENUES", venueList);
        commit("SET_LOADING", false);
      })
      .catch(err => console.error(err));
  },
  enableLocation({ commit }, locationPermission) {
    commit("TOGGLE_LOCATION_PERMISSION", locationPermission);
  }
};

const mutations = {
  TOGGLE_LOCATION_PERMISSION(state, locationPermission) {
    state.locationEnabled = locationPermission;
  },
  SET_VENUES(state, venues) {
    state.venues = venues;
  },
  SET_LOADING(state, loadingState) {
    state.loading = loadingState;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
